import axios from "axios";
import { APP_DISPLAY_ADS_API_ENDPOINT, APP_GOOGLE_PMAX_API_ENDPOINT, APP_GOOGLE_SEM_API_ENDPOINT, APP_AI_CONNECT_API_ENDPOINT,APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import { api_urls_charts } from "features/metasearch/chartContainer/utils";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSearchParams } from "react-router-dom";
import { getUserToken } from "utils/functions/userToken";

const useColumnSelection = (page) => {
    const token = getUserToken();
    const {platform = []} = useSelector(state => state?.metaSearch);

    const API_BASE_URL = useMemo(() => {
      if (page === "metaSearch") {
        return platform?.length > 1
          ? api_urls_charts["global"]
          : api_urls_charts?.[platform?.[0]?.id];
      }
      if (page === "searchAds") {
        return APP_GOOGLE_SEM_API_ENDPOINT;
      }
      if (page === "pMax") return APP_GOOGLE_PMAX_API_ENDPOINT;
      if (page === "displayAds") return APP_DISPLAY_ADS_API_ENDPOINT;
      if(page === "aiConnect") return APP_AI_CONNECT_API_ENDPOINT;
      if(page === "metaTravelAds") return APP_META_TRAVEL_ADS_API_ENDPOINT;
    }, [platform, page]);

    const handleColumnSelectionAPI = (selectedColumns) => {
    axios
      .post(
        `${API_BASE_URL}/api/update-columns-preference/?${createSearchParams(
          { "columns[]": selectedColumns || [] }
        )}`,{},{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
      )
      .then((res) => {
        console.log(res?.data);
      })
      .catch(console.error);
  };

  return {
    handleColumnSelectionAPI
  }
};

export default useColumnSelection;
